__turbopack_context__.v({
  "banner": "BetaAnnouncement-module__8t7r1W__banner",
  "close": "BetaAnnouncement-module__8t7r1W__close",
  "headerStack": "BetaAnnouncement-module__8t7r1W__headerStack",
  "message": "BetaAnnouncement-module__8t7r1W__message",
  "support": "BetaAnnouncement-module__8t7r1W__support",
});
